export const EstateApplicationSteps = [
  { title: 'Información básica', description: 'Confirma tus datos' },
  { title: 'Caracterización del aplicante', description: 'Ayudanos a conocerte' },
  { title: 'Documentos y certificaciones', description: 'Respaldo oficial de tu información' },
];